import Controller from '@ember/controller';
import type { ConnectorType } from 'scaleflow/utils/connectors-config';
import type IntegrationSetting from 'scaleflow/models/integration-setting';

export default class ConnectorsIndexController extends Controller {
  declare model: {
    connectors: ConnectorType[];
    integrations: IntegrationSetting[];
  };

  get connectorsWithStatus() {
    const integrations = [...this.model.integrations];
    const pendingIds = new Set(
      integrations
        .filter((i) => i.provider_id === 'pending')
        .map((i) => i.provider_name),
    );
    const connectedIds = new Set(
      integrations
        .filter((i) => i.provider_id !== 'pending')
        .map((i) => i.provider_name),
    );
    return this.model.connectors.map((c) => ({
      ...c,
      isPending: pendingIds.has(c.id),
      isConnected: connectedIds.has(c.id),
    }));
  }
}
